import { render, staticRenderFns } from "./WarningOne.vue?vue&type=template&id=f6bf124c&scoped=true"
import script from "./WarningOne.vue?vue&type=script&lang=js"
export * from "./WarningOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bf124c",
  null
  
)

export default component.exports